import React, { Component } from "react";
import { connect } from "react-redux";
import { getTranslate } from "react-localize-redux";
import { withActions, isBusy } from "actionware";
import { Spin, Typography, Popover, Button as AntdButton } from "antd";
import { getBorrowerDetails } from "../application/applicationApprovalActions";
import { getConfig } from '../../common/config';

const { Text } = Typography;

@connect(({ localize, applicationApproval: { productBorrowerMapping } }) => ({
  translate: getTranslate(localize),
  productBorrowerMapping,
}))
@withActions({
  getBorrowerDetails,
})
class BorrowerDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
    };
  }
  renderScore = (score) => {
    // Score display removed from frontend
    return null;
  };

  async onClickDetails(event, content, modalType = "approve", bulk = false) {
    event.stopPropagation();
    const { productBorrowerMapping, getBorrowerDetails } = this.props;
    // Check if borrower details are already present in the store
    if (
      !(content.product in productBorrowerMapping) ||
      !(content.borrower_user_id in productBorrowerMapping[content.product])
    ) {
      this.setState({ loading: true });
      await getBorrowerDetails({
        borrower_id: content.borrower_user_id,
        product_code: content.product,
        loan_application_id: content.application_id,
      });
      this.setState({ loading: false });
    }
  }

  getBorrowerDetails = () => {
    const { row, productBorrowerMapping } = this.props;
    if (
      row.product in productBorrowerMapping &&
      row.borrower_user_id in productBorrowerMapping[row.product]
    ) {
      return productBorrowerMapping[row.product][row.borrower_user_id];
    }
    return {};
  };

  renderPopoverContent = (borrowerDetails) => {
    const { translate } = this.props;
    const { loading } = this.state;

    if (loading) {
      return <Spin />;
    }

    return (
      <div>
        <div>
          <div>{translate("borrowerDetails.name")} : {borrowerDetails.name}</div>
          {this.renderScore(borrowerDetails.score)}
        </div>
      </div>
    );
  };

  renderButton = (borrowerDetails) => {
    const { translate, row } = this.props;

    return (
      <AntdButton
        type="default"
        className="decision button-group-inline"
        active="false"
        onClick={(e) => {
          e.stopPropagation();
          this.onClickDetails(e, row, "view");
        }}
      >
        {translate("loanTable.view")}
      </AntdButton>
    );
  };

  render() {
    const borrowerDetails = this.getBorrowerDetails();

    return (
      <div className="inline">
        <Popover
          content={this.renderPopoverContent(borrowerDetails)}
          title={this.props.translate("borrowerDetails.title")}
          trigger="click"
        >
          {this.renderButton(borrowerDetails)}
        </Popover>
      </div>
    );
  }
}

export default BorrowerDetails;
